exports.mapHTML = (lat, lon) => {
    return `<!DOCTYPE html>
<html>
<head>
  <title>Map with Circle</title>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <link rel="stylesheet" href="https://unpkg.com/leaflet/dist/leaflet.css" />
  <style>
    #map { height: 100vh; }
  </style>
</head>
<body>
  <div id="map"></div>
  <script src="https://unpkg.com/leaflet/dist/leaflet.js"></script>
  <script>
    // Your lat/lon
    const lat = ${lat};
    const lon = ${lon};

    // Initialize map
    const map = L.map('map').setView([lat, lon], 13);

    // Add OpenStreetMap tile layer
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);

    // Add marker
    L.marker([lat, lon]).addTo(map)
      .bindPopup('location')
      .openPopup();

    // Add circle (radius in meters)
    L.circle([lat, lon], {
      color: 'blue',
      fillColor: '#30f',
      fillOpacity: 0.3,
      radius: 1000 // 1 km
    }).addTo(map);
  </script>
</body>
</html>
`;
  };
  